// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"613":"cc96bfe5","644":"7b8198b6","646":"f9b31b59"}[chunkId] + ".chunk.js";
};